if (!customElements.get("rv-size-guide")) {
  class RvSizeGuide extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll("[data-unit]");

      this.charts = this.querySelectorAll("[data-size-chart]");

      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.buttons.forEach((button) => {
        button.addEventListener("click", this.handleToggle);
      });
    }

    disconnectedCallback() {
      this.buttons.forEach((button) => {
        button.removeEventListener("click", this.handleToggle);
      });
    }

    handleToggle(event) {
      const button = event.currentTarget;
      const unit = button.dataset.unit;

      this.setUnit(unit);
    }

    setUnit(unit) {
      // Update buttons
      this.buttons.forEach((button) => {
        const isActive = button.dataset.unit === unit;

        button.setAttribute("aria-pressed", isActive);
      });

      // Update tables
      this.charts.forEach((chart) => {
        chart.hidden = chart.dataset.sizeChart !== unit;
      });
    }
  }

  customElements.define("rv-size-guide", RvSizeGuide);
}
